import { gql, useQuery } from '@apollo/client';
import LOCALIZED_TEXT_FRAGMENT from 'apollo/fragments/localizedText';
import { LocalizedTicketTypes } from 'apollo/localizedTypes';

const LIST_TICKET_TYPES = gql`
  query listTicketTypes {
    listEntranceTicketTypesBackOffice {
      id
      name {
        ...LocalizedTextFields
      }
    }
    listActivitiesBackOffice {
      id
      name
    }
  }
  ${LOCALIZED_TEXT_FRAGMENT}
`;

const uselistTicketTypesQuery = () => {
  return useQuery<LocalizedTicketTypes>(LIST_TICKET_TYPES, {});
};
export default uselistTicketTypesQuery;
